export const isComponentSupportedForSite = (state, componentName) =>
  state.featureFlag.excludedComponentsForSite.every(item => item !== componentName)

export const excludedComponentsForSite = state => state.featureFlag.excludedComponentsForSite



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/store/featureFlags/featureFlags.selectors.js